import React from 'react'
import TaskGroupsDashboard from './TaskGroupsDashboard'

const TaskGroups = () => <TaskGroupsDashboard />

export default TaskGroups
